import { jobTab, treeAspectMinorTabgroup } from 'uix/views/utils';
let keepQueryParamOnIdChange = (clsname, tabname, param_name)=>{
    /* keep query param on id change (traversing tree nodes)
   */ return (nextRequest, nextQuery, oldRequest)=>{
        let { classname, query: oldQuery } = oldRequest;
        if (classname == clsname && nextRequest.classname == clsname && nextRequest.tabname == tabname && nextRequest.id !== oldRequest.id) {
            let oldVal = oldQuery[param_name];
            if (oldVal) {
                return {
                    query: {
                        [param_name]: oldVal,
                        ...nextQuery
                    }
                };
            }
            return {};
        }
    };
};
export const textlab = {
    ...treeAspectMinorTabgroup,
    tabGroup: 'lab',
    customizeRouting: keepQueryParamOnIdChange('textlab', 'compare', 'test_name'),
    // if dconfig.ocr.on == false then dconfig.ocr.textlab doesnt exist
    cfg: ({ dconfig, user })=>dconfig.ocr.on && dconfig.ocr.textlab.on || user.hasGroup('debug'),
    tabs: {
        start: {
            default: true,
            tabGroupDefault: true,
            enabled: ({ datatype, subtype, treeNode })=>treeNode.nodeType.startsWith('domain:byState') || [
                    10,
                    1,
                    0,
                    3
                ].includes(datatype) || datatype == 2 && [
                    26,
                    51
                ].includes(subtype),
            parts: [
                'OcrDashboard'
            ],
            minorTabGroup: 'start'
        },
        search: {
            datatype: [
                1,
                2,
                0
            ],
            parts: [
                'TreeSearchFulltext'
            ],
            order: 99
        },
        list: {
            datatype: [
                10,
                2,
                1,
                0
            ],
            parts: [
                {
                    type: 'OcrInfoList'
                }
            ],
            minorTabGroup: 'start'
        },
        recognition: {
            datatype: [
                0,
                3
            ],
            parts: [
                'FulltextEditor'
            ]
        },
        compare: {
            cfg: ({ dconfig })=>dconfig.ocr.on,
            datatype: [
                10,
                2,
                1,
                0,
                3
            ],
            parts: [
                'CompareEngineTests'
            ]
        },
        entities: {
            cfg: ({ dconfig })=>dconfig.namedEntities.on,
            datatype: [
                0,
                1,
                2,
                3,
                13,
                16,
                19,
                10
            ],
            parts: [
                'NamedEntities'
            ]
        },
        layout: {
            datatype: [
                0,
                1,
                3
            ],
            cfg: ({ dconfig })=>dconfig.ocr.textlab?.layout,
            parts: [
                'LayoutControl'
            ]
        },
        passages: {
            datatype: [
                3
            ],
            cfg: ({ iconfig })=>iconfig.lab.on,
            parts: [
                'PassageViewer'
            ]
        },
        history: {
            datatype: [
                3
            ],
            parts: [
                {
                    type: 'WikiHistory',
                    filters: [
                        'getWikiCode'
                    ]
                }
            ]
        },
        config: {
            order: 100,
            datatype: [
                10,
                0,
                1,
                2
            ],
            parts: [
                'TextlabConfig'
            ]
        },
        engines: {
            datatype: [
                10
            ],
            parts: [
                'EngineReports'
            ]
        },
        job: jobTab({
            names: 'ocr,fulltext',
            jobButton: [
                'OcrJob',
                'UpdateOcrResultStats'
            ]
        })
    }
};
